import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  scale: 1,
  rotate: 0,
  show: false,
  showText: false,
};

const controlSlice = createSlice({
  name: 'control',
  initialState,
  reducers: {
    setScale: (state, action) => {
      state.scale = action.payload;
    },
    setRotate: (state, action) => {
      state.rotate = action.payload;
    },
    setShow: (state, action) => {
      state.show = action.payload;
    },
    setControl: (state, action) => {
      const { scale, rotate, show } = action.payload;
      state.scale = scale;
      state.rotate = rotate;
      state.show = show;
    },
    setShowText: (state, action) => {
      state.showText = action.payload;
    },
  },
});

export const { setScale, setRotate, setShow, setControl, setShowText } = controlSlice.actions;
export default controlSlice.reducer;
